"use client";

import CountUp from "@/app/ui/atomic/animations/CountUp";

interface StatCardProps {
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  label: string;
  color?: "gold" | "pink" | "brand";
  borderColor?: "gold" | "pink" | "purple" | "brand" | "none";
  labelColor?: "gray" | "purple";
  compact?: boolean;
}

export default function StatCard({
  value,
  prefix = "",
  suffix = "",
  decimals,
  label,
  color = "pink",
  borderColor = "gold",
  labelColor = "gray",
  compact = false,
}: StatCardProps) {
  const colorClass = color === "gold" ? "text-(--gold-text)" : color === "brand" ? "text-(--brand)" : "text-(--brand)";
  const borderColorClass = borderColor === "none" 
    ? "" 
    : borderColor === "gold" 
    ? "border-l-4 border-(--gold-accent)" 
    : borderColor === "pink" 
    ? "border-l-4 border-(--brand)" 
    : borderColor === "brand"
    ? "border-l-4 border-(--brand)"
    : "border-l-4 border-(--purple-accent)";
  const labelColorClass = labelColor === "purple" ? "text-(--text-secondary)" : "text-(--text-muted)";
  const paddingClass = compact ? "p-5" : "p-6";

  return (
    <div className={`card-hover theme-card-alt rounded-xl ${paddingClass} shadow-sm ${borderColorClass}`}>
      <div className="text-center">
        <div className={`text-3xl md:text-4xl font-['Playfair_Display'] font-semibold ${colorClass}`}>
          <CountUp end={value} prefix={prefix} suffix={suffix} decimals={decimals} />
        </div>
        <div className={`text-sm ${labelColorClass} mt-1`}>{label}</div>
      </div>
    </div>
  );
}

interface StatGridProps {
  stats: {
    value: number;
    prefix?: string;
    suffix?: string;
    label: string;
    color?: "gold" | "pink" | "brand";
  }[];
}

export function StatGrid({ stats }: StatGridProps) {
  return (
    <div className="grid grid-cols-2 gap-4 mb-4">
      {stats.map((stat, index) => (
        <div key={index} className="text-center">
          <div className={`text-3xl md:text-4xl font-['Playfair_Display'] font-semibold ${stat.color === "gold" ? "text-(--gold-text)" : stat.color === "brand" ? "text-(--brand)" : "text-(--brand)"}`}>
            <CountUp end={stat.value} prefix={stat.prefix} suffix={stat.suffix} />
          </div>
          <div className="text-sm text-(--text-muted) mt-1">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}

interface CoopStatProps {
  value: number;
  suffix?: string;
  label: string;
}

export function CoopStat({ value, suffix = "", label, prefix = "" }: CoopStatProps & { prefix?: string }) {
  return (
    <div>
      <span className="font-['Playfair_Display'] font-semibold text-(--brand) text-2xl bg-(--purple) px-2 py-0.5 rounded">
        <CountUp end={value} prefix={prefix} suffix={suffix} />
      </span>
      <span className="text-(--text-muted) ml-2">{label}</span>
    </div>
  );
}
